import { LogLevel, logLevel } from 'aurelia-logging';

export * from './Appender';
export * from './getLogger';
export * from './interfaces';
export * from './setDefaultAppender';
export * from './setLevels';
export * from './SimpleConsoleAppender';
export { LogLevel, logLevel };

